import { useEffect, useState } from "react";
import "./InstructionPage.css";
import TemplateInstruction from "./TemplateInstruction/TemplateInstruction";
import { IMG_PLACEHOLDER_PRODUCT, INSTRUCTION_KEY, TYPE } from "../../assets/utils/constants";


function InstructionPage() {
    const [active, setActive] = useState(0);

    function isMatch(main, search) {
        return main.includes(search) || search.includes(main);
    }

    useEffect(() => {
        const storedTitle = localStorage.getItem(INSTRUCTION_KEY) || ""; // Handle null case
        const foundIndex = TYPE.findIndex(item => isMatch(storedTitle, item.title));

        setActive(foundIndex !== -1 ? foundIndex : 0); // Default to first item if no match
    }, [TYPE]);

    return (
        <div className={`instruction-page`}>
            <div className="instruction-page__menu">
                {TYPE.map((item, i) => {
                    return (
                        <button onClick={() => setActive(i)} className={` instruction-page__card zamer-info__item_tabs ${active === i ? 'zamer-info__tabs_active' : ''}`} key={i} type='button'>
                            <img src={item.img ? item.img : IMG_PLACEHOLDER_PRODUCT} alt="" className="instruction-page__card__img"></img>
                            <p className="instruction-page__card__text">{item.title}</p>
                        </button>
                    )
                })}
            </div>
            <TemplateInstruction active={active} />
        </div >
    );
}

export default InstructionPage;